import { observer } from "mobx-react"
import HtmlParser from "react-html-parser"
import classNames from "classnames"
import { useStore } from "@features/common"
import { RouterLink } from "@lib/routing"
import { useRouter } from "next/router"
import { exactSubstringSearch } from "@lib/helpers/helpers"
import { FireIcon } from "@lib/icons/fire-icon"

export const SpecProjectsNav = observer(() => {
  const { GlobalModel } = useStore()
  const router = useRouter()

  if (GlobalModel.specProjectsByLang.length <= 0) return null

  return (
    <ol className="space-y-5 list-none mb-5">
      {GlobalModel.specProjectsByLang.map((project, index) => {
        if (project.in_journal) {
          return (
            <li key={`project-${index}`}>
              <RouterLink
                uri={project.url}
                routing={false}
                className={classNames(
                  "inline-flex items-start font-sans text-2xl tracking-2 uppercase transition-colors duration-100 ease-in hover:text-pink-300 hover:fill-pink-300",
                  {
                    "text-pink-300 cursor-default pointer-events-none fill-pink-300": exactSubstringSearch(
                      router.asPath.split("?")[0],
                      project.slug,
                    ),
                  },
                )}
                onClick={GlobalModel.closeMenu}
                data-test-id="navigation__special_project"
              >
                <p className="m-0">{HtmlParser(project.text)}</p>
                <FireIcon className="w-6 h-6 ml-1 shrink-0" />
              </RouterLink>
            </li>
          )
        }
        return null
      })}
    </ol>
  )
})
